module.exports = __webpack_public_path__ + "media/images/university_logos/SOAS-University-of-London-5bc9e664ac0be53241bd523a7420a5fb.svg";